import offerPageStateReducer, { OfferPageDispatchAction, OfferPageState } from 'contexts/OfferPage/offerPageStateReducer'
import { EmptyArray } from 'lib/array/arrayUtils'
import { ReducerMiddleware } from 'lib/redux/reducerUtils'
import { Dispatch, MutableRefObject, useCallback, useEffect, useMemo, useReducer, useRef } from 'react'

type ReturnType = [OfferPageState, Dispatch<OfferPageDispatchAction>, MutableRefObject<OfferPageState>]

function useOfferPageReducer(
  defaultState: OfferPageState,
  middlewares: Array<ReducerMiddleware<OfferPageState, OfferPageDispatchAction>> = EmptyArray,
): ReturnType {
  const [reducer, snapshotReducer] = useMemo(() => {
    return [
      offerPageStateReducer(middlewares, true),
      offerPageStateReducer(),
    ]
  }, [middlewares])
  const [state, dispatch] = useReducer(reducer, defaultState)
  const stateSnapshotRef = useRef(state)

  useEffect(() => {
    stateSnapshotRef.current = state
  }, [state])

  const dispatchToSnapshot = useCallback((action: OfferPageDispatchAction) => {
    stateSnapshotRef.current = snapshotReducer(stateSnapshotRef.current, action)
    return dispatch(action)
  }, [snapshotReducer])

  return useMemo<ReturnType>(() => {
    return [state, dispatchToSnapshot, stateSnapshotRef]
  }, [state, dispatchToSnapshot, stateSnapshotRef])
}

export default useOfferPageReducer
